import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Users, Headphones } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Avatar } from "@/components/AttendeesModal";

export default function FollowListModal({ userId, kind, onClose }) {
  const { t } = useApp();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/users/${userId}/follows`, { params: { kind } }).then(r => setItems(r.data.items)).catch(() => setItems([])); }, [userId, kind]);

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-end sm:items-center justify-center" onClick={onClose} data-testid="follow-list-modal">
      <div onClick={e => e.stopPropagation()} className="gg-card bg-background w-full sm:max-w-md max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-foreground">
          <h3 className="font-display uppercase text-xl flex items-center gap-2" data-testid="follow-list-title">
            <Users className="w-5 h-5 text-primary" />{t(kind === "followers" ? "followersTitle" : "followingTitle")}
          </h3>
          <button onClick={onClose} className="gg-icon-btn" aria-label={t("cancel")} data-testid="follow-list-close"><X className="w-5 h-5" /></button>
        </div>
        <ul className="overflow-y-auto divide-y divide-foreground" data-testid="follow-list">
          {(items || []).map(u => (
            <li key={u.user_id}>
              <Link to={`/users/${u.user_id}`} onClick={onClose} className="flex items-center gap-3 p-3 hover:bg-muted transition-colors" data-testid={`follow-item-${u.user_id}`}>
                <Avatar user={u} />
                <span className="min-w-0"><span className="block font-display text-base leading-tight">{u.name}</span>
                  {u.dj_name && <span className="flex items-center gap-1 text-xs text-muted-foreground"><Headphones className="w-3 h-3" />{u.dj_name}</span>}</span>
              </Link>
            </li>
          ))}
          {items && items.length === 0 && <li className="p-6 text-center text-sm text-muted-foreground" data-testid="follow-list-empty">{t("nobodyHereYet")}</li>}
          {!items && <li className="p-6 text-center eyebrow">…</li>}
        </ul>
      </div>
    </div>
  );
}
